export default {
    state: {
        mainTabs: [], // 主入口标签页
        activeTabName: '' // 当前标签页名
    },
    getters: {

    },
    mutations: {
        updateMainTabs(state, tabs) { // 设置主入口标签页
            state.mainTabs = tabs
        },
        updateActiveTabName(state, name) { // 设置当前标签页名
            state.activeTabName = name
        }
    },
    actions: {

    }
}



// WEBPACK FOOTER //
// ./src/store/modules/tab.js